const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true
  },
  {
    prop: 'status',
    label: 'Status',
    sortable: true
  },
  {
    prop: 'createdOn',
    label: 'Created on',
    sortable: true
  }
];

const tableFilters = [
  {
    label: 'Inactive',
    name: 'inactive',
    search: 'status',
    param: 'pending'
  },  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions };
